<template>
  <div class="cards-swipe--wrap">
    <div class="game--row title-row">
      <h3>
        {{
          $i18n.locale == 'it' ?
          "Metti alla prova le tue attuali scelte alimentari trascinando ogni carta sul lato che descrive meglio le tue abitudini!"
          :
          "Put your current food choices to the test by dragging each statement to the side that describes you best."
          }}
        </h3>
    </div>
    <div class="game--row">
      <vue-swing
        @throwoutleft="throwoutleft"
        @throwoutright="throwoutright"
        @throwoutend="throwoutend"
        @dragstart="hideControls(true)"
        @dragend="hideControls(false)"
        :config="config"
        class="swing-wrap"
        ref="wrapper"
      >
        <div class="card" 
          v-for="(card, index) in cards" :key="index" 
          :style="{zIndex: ((cardCount + 3) - index) + ( cards.length - cardCount)   }"
        >
          <div class="card--inner"
            :style="{
              transform: windowWidth > 1023 ? 
                         `rotate(${ ( (index + cardCount) - (cards.length - 1)) * 5 }deg)`
                         : `translateY(-${ ((index + cardCount) - (cards.length - 1)) * 5 }px)`, 
            }"
          >
            <div class="img--wrap">
              <img :src="$i18n.locale == 'it' ? card.imgITA : card.img" />
            </div>
          </div>
          
        </div>
          
      </vue-swing>
      <div class="mobile-indicator">
        <img src="../assets/cards-game/arrow-prev.svg" />
        <img src="../assets/cards-game/arrow-next.svg" />
      </div>
    </div>
    <div class="throw--areas-wrap">
      <div class="throw--area area-some" >
        <p>
          {{
            $i18n.locale == 'it' ? 
            cards[currentIndex].leftTextITA
            :
            cards[currentIndex].leftText
          }}
        </p>
      </div>
      <div class="throw--area area-often">
        <p>
          {{
            $i18n.locale == 'it' ? 
            cards[currentIndex].rightTextITA
            :
            cards[currentIndex].rightText
          }}
        </p>
      </div>
    </div>
    <div class="mobile-choices">
      <div class="choice">
        <p>
          {{
            $i18n.locale == 'it' ? 
            cards[currentIndex].leftTextITA
            :
            cards[currentIndex].leftText
          }}
        </p>
      </div>
      <div class="choice">
        <p>
          {{
            $i18n.locale == 'it' ? 
            cards[currentIndex].rightTextITA
            :
            cards[currentIndex].rightText
          }}
        </p>
      </div>
    </div>
    <div class="final--result">
      <div class="balloon">
        <p v-html="balloonResult"></p>
      </div>
      <div class="avatar--res">
        <img :src=" countOften > countSometimes ? require(`../assets/cards-game/planet-happy.svg`) : require(`../assets/cards-game/planet-sad.svg`) "/>
      </div>
      <div class="cta-badge-cards" @click="openBadgeOverlay">
        {{
            $i18n.locale == 'it' ?
            "Sono pronto/a ad imparare!"
            :
            "I'm ready to learn!"
        }}
      </div>
    </div>
    <div class="overlay-steps-wrap">
      <div class="overlay-step" 
        v-for="(card, index) in cards" :key="index" 
        :style="{
          backgroundColor: card.overlayBg,
          color: (index%2 > 0) ? '#000' : '#FFF'
        }"
      >
        <div class="inner--overlay">
          <h6>
            {{
            $i18n.locale == 'it' ? 
            card.titleOverlayITA
            :
            card.titleOverlay
            }}
          </h6>
          <p>
            {{
              $i18n.locale == 'it' ? 
              card.textOverlayITA
              :
              card.textOverlay
            }}
          </p>
          <img :src="card.imgOverlay" />

          <div class="cta-next" @click="closeOverlay" :style="{backgroundColor: index == 0 || index == 2 ? '#E86E36' : '#2E70E2'}">
            {{
              $i18n.locale == 'it' ? 
              "CONTINUA"
              :
              "NEXT"
            }}
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import VueSwing from 'vue-swing'
import {gsap, Power2} from 'gsap'

  export default {
    name: "CardSwipeGame",
    props:['isOverlay'],
    components:{
      VueSwing
    },
    data(){
      return{
        config: {
          allowedDirections: [
            VueSwing.Direction.LEFT,
            VueSwing.Direction.RIGHT
          ],
          minThrowOutDistance: window.innerWidth > 1023 ? 250 : 15,
          maxThrowOutDistance: window.innerWidth,
          throwOutConfidence: (xOffset, yOffset, element) => {
              const xConfidence = Math.min(
              Math.abs(xOffset) / (element.offsetWidth / 2),
              1
              );
              const yConfidence = Math.min(
              Math.abs(yOffset) / element.offsetHeight,
              1
              );
              const max = Math.max(xConfidence, yConfidence);
              return max;
          }
        },
        isShowingControls: true,
        cards: [
          {
            leftText: 'I’LL PITCH IT',
            leftTextITA: 'LA BUTTO',
            rightText:'I’LL HAVE IT FOR TOMORROW’S LUNCH!',
            rightTextITA:'LA MANGIO DOMANI PER PRANZO',
            img: require('../assets/cards-game/game-1.png'),
            imgITA: require('../assets/cards-game/IT/game-1.png'),
            titleOverlay: 'AVOID WASTE',
            titleOverlayITA: 'EVITA LO SPRECO',
            textOverlay: 'by putting only what you need on my plate, freezing the excess and reusing it for new recipes.',
            textOverlayITA: 'mettendo sul piatto solo ciò che ti serve, congelando il cibo in eccesso e riutilizzandolo per nuove ricette.',
            imgOverlay: require('../assets/cards-game/overlay/1.png'),
            overlayBg: 'rgba(80, 175, 114, 0.95)'
          },
          {
            leftText: 'YES!',
            leftTextITA: 'SI!',
            rightText:'No, nectarines are hot season fruit',
            rightTextITA:'No, le pesche sono frutti della stagione calda',
            img: require('../assets/cards-game/game-2.png'),
            imgITA: require('../assets/cards-game/IT/game-2.png'),
            titleOverlay: 'FOLLOW THE SEASONS',
            titleOverlayITA: 'SEGUI LE STAGIONI',
            textOverlay: 'by choosing local, seasonal and traditional ingredients, and by eating more vegetables, legumes, whole grains, fresh fruit, and nuts.',
            textOverlayITA: 'scegliendo ingredienti di stagione, locali e di tradizioneali, e consumando più verdura, legumi, cereali integrali, frutta fresca e frutta a guscio.',
            imgOverlay: require('../assets/cards-game/overlay/2.png'),
            overlayBg: 'rgba(249, 220, 95, 0.95)'
          },
          {
            leftText: 'Buy a bottle of water somewhere',
            leftTextITA: 'Compro una bottiglia d’acqua da qualche parte.',
            rightText:'Fill up your bottle water with tap water',
            rightTextITA:'Riempio una borraccia con acqua di rubinetto.',
            img: require('../assets/cards-game/game-3.png'),
            imgITA: require('../assets/cards-game/IT/game-3.png'),
            titleOverlay: 'VALUE THE WATER YOU USE',
            titleOverlayITA: 'DAI IMPORTANZA ALL’ACQUA CHE USI',
            textOverlay: 'by drinking plenty of water and choosing tap water over bottled water when safe, without wasting it.',
            textOverlayITA: 'bevendo molta acqua e preferendo (quando è sicura) l’acqua di rubinetto all’acqua in bottiglia, senza sprecarla.',
            imgOverlay: require('../assets/cards-game/overlay/3.png'),
            overlayBg: 'rgba(46, 112, 226, 0.95)'
          },
          {
            leftText: 'YES!',
            leftTextITA: 'SI!',
            rightText:'No, too much meat this week, better a veggie burger!',
            rightTextITA:'No, troppa carne questa settimana, meglio pesce o legumi!',
            img: require('../assets/cards-game/game-4.png'),
            imgITA: require('../assets/cards-game/IT/game-4.png'),
            titleOverlay: 'EAT HEALTHY AND SUSTAINABLE FOOD',
            titleOverlayITA: 'CONSUMA CIBO SANO E SOSTENIBILE',
            textOverlay: 'by following the suggestions of the Double Health and Climate Pyramid.',
            textOverlayITA: 'seguendo le raccomandazioni di modelli alimentari sostenibili, come quello proposto dalla Doppia Piramide della Salute e del Clima.',
            imgOverlay: require('../assets/cards-game/overlay/4.png'),
            overlayBg: 'rgba(226, 231, 236, 0.95)'
          },
          {
            leftText: 'Linger in bed chatting, watching a movie!',
            leftTextITA: 'Sto a letto a chattare o guardare un film.',
            rightText:'I call up a friend and go out for a walk or run!',
            rightTextITA:'Vado a fare una corsa o una passeggiata!',
            img: require('../assets/cards-game/game-5.png'),
            imgITA: require('../assets/cards-game/IT/game-5.png'),
            titleOverlay: 'LIVEN UP YOUR DAY',
            titleOverlayITA: 'RAVVIVA LA TUA GIORNATA',
            textOverlay: 'by staying active and moving every day, to be healthier and more energetic.',
            textOverlayITA: 'rimanendo attivo/a e muovendoti di più ogni giorno, per essere più sano/a e pieno/a di energia.',
            imgOverlay: require('../assets/cards-game/overlay/5.png'),
            overlayBg: 'rgba(126, 50, 180, 0.95)'
          },
          {
            leftText: 'I buy what I feel at the moment',
            leftTextITA: 'Decido cosa comprare al momento',
            rightText:'I make a list and bring containers from home',
            rightTextITA:'Faccio una lista e mi porto i contenitori da casa',
            img: require('../assets/cards-game/game-6.png'),
            imgITA: require('../assets/cards-game/IT/game-6.png'),
            titleOverlay: 'MAKE CONSCIOUS CHOICES',
            titleOverlayITA: 'FAI SCELTE CONSAPEVOLI',
            textOverlay: ' by preferring food that is produced by a sustainable supply chain and by reducing, reusing, and recycling food packaging, and other disposable materials.',
            textOverlayITA: 'preferendo il cibo prodotto da una filiera sostenibile e riducendo, riutilizzando e riciclando gli imballaggi alimentari e altri materiali usa e getta.',
            imgOverlay: require('../assets/cards-game/overlay/6.png'),
            overlayBg: 'rgba(239, 169, 221, 0.95)'
          },
          {
            leftText: 'Scuoto la testa, io so cos’è meglio.',
            leftTextITA: 'Shake your head, you know best.',
            rightText:'You know best, set the example and talk them through!',
            rightTextITA:'So cos’è meglio, do l’esempio e gliene parlo!',
            img: require('../assets/cards-game/game-7.png'),
            imgITA: require('../assets/cards-game/IT/game-7.png'),
            titleOverlay: 'SPREAD THE WORD',
            titleOverlayITA: 'DIFFONDI LA NOTIZIA',
            textOverlay: 'by making positive suggestions and, if possible, making concrete solutions for my family, my school, and my neighborhood. ',
            textOverlayITA: 'dando consigli costruttivi e, se possibile, offrendo soluzioni concrete alla tua famiglia, alla tua scuola e ai tuoi vicini.',
            imgOverlay: require('../assets/cards-game/overlay/7.png'),
            overlayBg: 'rgba(229, 52, 44, 0.95)'
          }
        ],
        cardCount: 6,
        windowWidth: window.innerWidth,
        countSometimes: 0,
        countOften: 0,
        balloonResult: '',
        currentIndex: 0
      }
    },
    methods:{
      throwoutleft({ target, throwDirection }){
        this.countSometimes = this.countSometimes + 1
      },
      throwoutright({ target, throwDirection }){
        this.countOften = this.countOften + 1
      },
      throwoutend({target, throwDirection}){
        
        gsap.to(target, {duration: .15, autoAlpha: 0, scale: 0});
        
        let overlays = document.querySelectorAll('.overlay-step');
        gsap.set('.overlay-steps-wrap', {top: 0});
        gsap.to(overlays[this.currentIndex], {opacity: 1,top: 0, duration: 0.35, onComplete: () =>{
          this.cardCount = this.cardCount - 1;
        }});
        if(this.currentIndex < 6) {
          this.currentIndex += 1;
        }
      },  

      hideControls(show){
        if(this.currentIndex >= 6) gsap.to('.mobile-indicator', {autoAlpha: 0, duration: 0.1});
        else{
          gsap.to('.mobile-indicator', {autoAlpha: show ? 0 : 1, duration: 0.15, delay: show ? 0 : 0.5})
          this.isShowingControls = !show
        }
      },
      closeOverlay(){
        let overlays = document.querySelectorAll('.overlay-step');
        
        gsap.to(overlays[this.currentIndex -  1], {opacity: 0,top: '100%', duration: 0.25, onComplete: () =>{
          if(this.cardCount < 0) this.showResult()
          gsap.set('.overlay-steps-wrap', {top: '100%'})
        }})
      },
      showResult(){

        if(this.countOften > this.countSometimes)
          this.balloonResult = 
          this.$i18n.locale == 'it' ?
          `
          Wow! 👏👏👏<br><br>Le tue scelte mi rendono già un pianeta più sano, sostenibile e felice. 😍 Ma dobbiamo imparare ancora molto di più!

          `
          :
          `
            Wow! 👏👏👏<br><br>Your choices already make me a more sustainable, healthier and happier planet. 😍 But there’s still a lot more for us to learn!
          `
        else this.balloonResult = 
          this.$i18n.locale == 'it' ?
          `
          Pare che tu debba lavorare ancora un pochino… 😥<br><br>Vediamo se ti possiamo spiegare meglio come compiere scelte sane e sostenibili per te e per me.
          `
          :
          `
          Looks like you still have some work to do... 😥<br><br>Let’s see if we can teach you some more about making healthy and sustainable choices for you and me.
          `

        gsap.to('.throw--areas-wrap',{autoAlpha: 0, duration: .5, ease: 'Power2.easeInOut'})
        gsap.to('.mobile-choices',{autoAlpha: 0, duration: .5, ease: 'Power2.easeInOut'})
        gsap.to('.title-row', {autoAlpha: 0, duration: .5, ease: 'Power2.easeInOut', onComplete: () =>{
          
          gsap.to('.final--result',{duration: .5, autoAlpha: 1, ease: 'Power2.easeInOut'})
          gsap.to('.cards-game-wrap .balloon',{duration: .5, delay: .5, autoAlpha: 1, ease: 'Power2.easeInOut'})
          gsap.to('.cards-game-wrap .avatar--res',{duration: .5, delay: .75, opacity:1, x: 0, ease: 'Power2.easeInOut'})
          gsap.to('.cta-badge-cards',{duration: .5, delay: 1, opacity:1, ease: 'Power2.easeInOut'})
        }})
      },
      resize(){
        
        this.windowWidth = window.innerWidth
      },
      openBadgeOverlay(){
        this.$store.dispatch('openBadge', 'cards')
      }
    },
    mounted(){
      window.addEventListener('resize', this.resize)
      this.resize()
    },
    beforeDestroy(){
      window.removeEventListener('resize', this.resize)
    },
    
  }
</script>

<style lang="scss">

  .cards-swipe--wrap{
    position: absolute;
    top: 0;
    left: 100%;
    height: 100%;
    width: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    overflow: hidden;
    @media screen and (max-width: 768px){
      justify-content: space-between;
      background-image: linear-gradient(to right, #E86E36 50%, #E86E36, #DD632B 50%, #DD632B);
    }
    .mobile-indicator{
      display: none;
      @media screen and (max-width: 768px){
        display: block;
        position: absolute;
        bottom: 0;
        transform: translate(-50%, 0);
        left: 50%;
        width: 130px;
        height: 65px;
        z-index: 10;
        border-top-left-radius: 131px;  /* 100px of height + 10px of border */
        border-top-right-radius: 131px; /* 100px of height + 10px of border */
        border: 1px solid #000;
        border-bottom: 0;
        box-sizing: border-box;
        display: flex;
        align-items: flex-end;
        justify-content: space-around;
        background-image: linear-gradient(to right, #E86E36 50%, #E86E36, #DD632B 50%, #DD632B);
      }
    }
    .mobile-choices{
      display: none;
      @media screen and (max-width: 768px){
        display: block;
        position: relative;
        bottom: 0;
        width: 100%;
        height: 20%;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        .choice {
          flex: 1 0 50%;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          p{
            font-size: 16px;
            line-height: 24px;
            padding: 10px 16px 0;
            color: #fff;
            font-weight: 700;
            text-transform: uppercase;
          }
        }
      }
    }
    .throw--areas-wrap{
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      transform: translateY(-50%);
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      z-index: 2;
      pointer-events: none;
      .throw--area{
        width: 240px;
        height: 240px;
        border: 1px solid #fff;
        display: flex;
        align-items: center;
        text-align: center;
        margin: 0 30px;
        border-radius: 50%;
        color: #fff;
        p{
          margin: 0 auto;
          text-transform: uppercase;
          font-weight: 700;
          font-size: 24px;
          line-height: 32px;
          padding: 0 20px;
        }
      }
      
      @media screen and (max-width: 1023px) {
        margin-top: 7%;
      }
      @media screen and (max-width: 768px) {
        .throw--area{
          display: none;
        }
      }
    }
    .game--row{
      position: relative;
      width: 100%;
      &:nth-child(1){
        height: 15%;
        display: flex;
        justify-content: center;
        max-width: 60%;
        color: #fff;
        h3{
          margin-bottom: 20px;
        }
      }
      &:nth-child(2){
        height: 75%;
        margin-bottom: 40px;
      }
      @media screen and (max-width: 1023px) {
        &:nth-child(1){
          height: 25%;
          align-items: center;
          max-width: 60%;
          h3{
            font-size: 16px;
          }
        }
        &:nth-child(2){
          height: 70%;
          margin-top: 20%;
        }
      }
      @media screen and (max-width: 1023px) {
        &:nth-child(1){
          display: none;
        }
      }
    }
    .swing-wrap{
      position: relative;
      width: auto;
      height: 100%;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
    }
    .card{
      position: absolute;
      width: auto;
      height: 100%;
      transition: transform .15s ease-out;
      .card--inner{
        position: relative;
        width: auto;
      height: 100%;
        transition: transform .15s ease-out;
        display: flex;
        .img--wrap{
          position: relative;
          width: auto;
          height: 100%;
          img{
            display: block;
            width: auto;
            height: 100%;
          }
        }
        @media screen and (max-width: 768px) {
          
          p{
            padding: 0 10px;
            font-size: 14px;
            line-height: 16px;
          }
        }
      }
      img{
        display: block;
        width: 100%;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -o-user-select: none;
        user-select: none;
        -webkit-user-drag: none;
        -khtml-user-drag: none;
        -moz-user-drag: none;
        -o-user-drag: none;
        user-drag: none;
      }
    }
    .final--result{
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      height: auto;
      width: 80%;
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      opacity: 0;
      visibility: hidden;
      z-index: 3;
      .balloon{
        align-self: stretch;
        padding: 50px 20px;
        background-color: #fff;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
        border-bottom-right-radius: 5px;
        text-align: center;
        font-size: 24px;
        opacity: 0;
        margin-bottom: 20px;
      }
      .avatar--res{
        position: absolute;
        bottom: 0;
        transform: translate(-100%, 50%);
        left: 0;
        opacity: 0;
        margin: 0;
        width: 150px;
        img{
          display: block;
          width: 100%;
        }
      }
      .cta-badge-cards{
        text-align: right;
        margin: 20px 0 0 auto;
        border: 1px solid #2E70E2;
        background-color: #2E70E2;
        color: #fff;
        padding: 16px 20px;
        font-size: 18px;
        border-radius: 5px;
        cursor: pointer;
        opacity: 0;
      }
      @media screen and (max-width: 768px) {
        top: 80px;
        transform: translateY(0);
        .balloon{
          padding: 20px;
          font-size: 18px;
        }
        .cta-badge-cards{
          font-size: 18px;
        }
        .avatar--res{
          width: 100px;
          transform: translateX(-100%) translateY(80%);
        }
      }
    }

    .overlay-steps-wrap{
      position: absolute;
      width: 100%;
      height: 100%;
      top: 100%;
      left: 0;
      z-index: 12;
      .overlay-step{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 100%;
        left: 0;
        opacity: 0;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        .inner--overlay{
          position: relative;
          max-width: 62.5%;
          height: auto;
          text-align: center;
          
          @media screen and(max-width: 768px) {
            max-width: 80%;
          }
          h6{
            font-size: 48px;
            line-height: 56px;
            font-weight: 700;
            margin-bottom: 16px;
            @media screen and(max-width: 768px) {
              font-size: 32px;
              line-height: 40px;
              margin-bottom: 24px;
            }
          }
          p{
            font-size: 24px;
            line-height: 32px;
            @media screen and(max-width: 768px) {
              font-size: 20px;
              line-height: 24px;
            }
          }
          img {
            display: block;
            width: 320px;
            height: auto;
            margin: 40px auto;
            @media screen and(max-width: 768px) {
              width: 200px;
              margin: 20px auto;
            }
          }
          .cta-next{
            display: inline-block;
            padding: 12px 40px;
            border-radius: 5px;
            color: #fff;
            align-self: center;
            font-weight: 500;
            margin: 0 auto;
            cursor: pointer;
            @media screen and(max-width: 768px) {
              padding: 16px 24px;
            }
          }
        }
      }
    }
  }
</style>